import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import LayoutBlog from "../components/LayoutBlog"
import SeoBlog from "../components/SeoBlog"

const MhPage = ({ data: { page } }) => {
  return (
    <LayoutBlog>
      <SeoBlog title={page.seo.title} description={page.seo.metaDesc} />

      <div className="content bg">
        <section className="bg-light">
          <div className="container-xl">
            <div className="row">
              <div className="col-12 col-lg-6">
                <h1 className="page-title text-dark mb-4 d-inline-block">
                  {page.title}
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container-xl">
            <div className="row">
              <div className="col-12 col-md-12">
                {!!page.content && <>{parse(page.content)}</>}
                <span className="me-2 my-3">
                  <small>Last Updated : {page.date}</small>
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </LayoutBlog>
  )
}

export default MhPage

export const PageQuery = graphql`
  query PageById($id: String!) {
    page: wpPage(id: { eq: $id }) {
      id
      content
      title
      seo {
        title
        metaDesc
      }
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`
